<template>
<div class="chapter">
<div class="inner_page">
<div id="OldFlames_epub-6.html" xml:lang="en-US">
<div class="story">
<p class="CT-new-page para-style-override-11"><span class="Section-Symbol char-style-override-16">‘</span><span class="char-style-override-16">. . . SIS would not merely defend the traditional decencies of our society: it would embody them. Within its own walls, its clubs and country houses, in whispered luncheons, with its secular contacts, it would enshrine the mystical entity of a vanishing England. Here at least, whatever went on in the big world outside, England’s flower would be cherished. “The Empire may be crumbling; but within our secret elite, the clean-limbed tradition of English power would survive. We believe in nothing but ourselves”.’</span></p>
<p class="BT para-style-override-7"><span class="char-style-override-17">John le Carré</span></p>
<p class="EPI-note para-style-override-7">(from his introduction to <span class="char-style-override-2">Philby: The Spy Who Betrayed a Generation.</span></p>
<p class="EPI-note para-style-override-7">Page, Leitch &amp; Knightley 1968.)</p>
<p class="EPI para-style-override-12">‘To betray, you must first belong.’</p>
<p class="EPI-source para-style-override-13"><span class="char-style-override-18">Kim Philby</span></p>
<p class="EPI-note para-style-override-14">(in an interview with Murray Sayle 1967)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OldFlames_epub6.vue?388ee8b5